import { useEffect } from 'react';

export function useNewRelicUser(userId: string | number | undefined) {
  useEffect(() => {
    if (!window.__NR_AGENT_INITIALIZED__ || !window.newrelic) {
      return;
    }

    console.log('Setting New Relic user ID:', userId);
    window.newrelic.setUserId(String(userId));
  }, [userId]);
}
